<template>
	<div>
		<CustomerView :user="this.user" />
		<ModalLoading />

	</div>
</template>

<style scoped src="@/assets/styles/beneficiary.css"></style>

<script>
import CustomerView from "@/views/company/customer/Customer.vue";
import Cookies from "js-cookie";
import ModalLoading from "@/components/ModalLoading.vue";


export default {
	components: {
		CustomerView,
		ModalLoading
	},
	data() {
		return {
			userLink: "",
			token: "",
			user: null,
			dataLoaded: false,
			readMessagesCount: 0,
		};
	},
	created() {
		this.showModalPopup("modal_popup_loading", true);

		// if (!Cookies.get("userLink")) {
		// 	this.$router.push({
		// 		name: "login",
		// 		params: { loginUserSelected: false },
		// 	});
		// }
		if (this.user == null) {
			this.user = this.getUserData();
		} else {
			this.showModalPopup("modal_popup_loading", false);

		}

	},
	watch: {
		'$store.state.customerDataLoaded': {
			handler() {
				// update locally relevant data
				this.user = this.getUserData();

			}
		}
	}
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
